import { $ } from "./imports";

const headerFunctions = () => {
    let header = document.querySelector('.header');
    let prevScrollpos = window.scrollY;
    let searchDropdown, langDropdown;
    let headerTimeout = false;

    if($('.search-dropdown__form').length > 0 ){
        searchDropdown =  bootstrap.Dropdown.getOrCreateInstance(document.querySelector('.search-dropdown__form'));
    }    
    if( $('.lang-menu__list').length > 0){
        langDropdown =  bootstrap.Dropdown.getOrCreateInstance(document.querySelector('.lang-menu__list'));
    }
    
    window.addEventListener('scroll', function(){
        // Añade color fondo header
        if(this.window.scrollY > 70){
            header.classList.add('active-scroll');
        }else{
            header.classList.remove('active-scroll')
        }
        
        if( !$('.header').hasClass('active') ){
            /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
            let currentScrollPos = window.scrollY;
            if (prevScrollpos > currentScrollPos) {
                header.style.top = "0";
            } else {
                header.style.top = `-${header.offsetHeight}px`;
                // Cerrar dropdowns de busqueda y lenguaje
                if(searchDropdown){
                    searchDropdown.hide();
                }
                if(langDropdown){
                    langDropdown.hide();
                }
            }
            prevScrollpos = currentScrollPos;
        }

    });

    function removeClassesDesktop(){
        if ( $(window).width() > 992 ) {
            if( $('.header').hasClass('active') ){
                $('.header').removeClass('active');
                $('.header .navbar-toggler').removeClass('is-active').attr('aria-expanded', 'false');
                $('.header .navbar-collapse').removeClass('show');
                $('body').removeClass('overflow-hidden');
            }
        }
    }

    /*==================== WINDOW RESIZE ====================*/
    window.addEventListener('resize', function () {
        this.clearTimeout(headerTimeout);
        headerTimeout = this.setTimeout(removeClassesDesktop, 250);
    });
}

export default headerFunctions;